import emerging from './extra_assets/json_maps/lesson-plan-pdf-emerging-reader.json';
import pre_readers from './extra_assets/json_maps/lesson-plan-pdf-pre-reader.json';
import fluency from './extra_assets/json_maps/lesson-plan-pdf-fluency.json';
const emerging_map = [...emerging]
const pre_readers_map=[...pre_readers]
const fluency_map=[...fluency]
export {emerging_map, pre_readers_map,fluency_map}
